import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Layout from "../Components/Layout/Layout";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getUpcomingEvent } from "../Redux/Actions/eventData";

export default function About() {
  const dispatch = useDispatch();

  const eventUpcoming = useSelector((e) => e.eventAuth.upcomingEvent);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    dispatch(getUpcomingEvent());
  }, [dispatch]);

  const musician = eventUpcoming?.musician;
  const musicianName = musician?.fullName?.trim() || "";

  // Profile picture uploaded from the admin panel; without one the text uses the full width
  const musicianImage = musician?.image || null;
  const imageOnLeft = musicianName.startsWith("Estere");

  // A blank line in the About text starts a new paragraph
  const aboutParagraphs = (musician?.about || "")
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  const socialLinks = [
    { href: musician?.instagram, icon: require("../Assets/Images/insta.png"), label: "Instagram" },
    { href: musician?.tiktok, icon: require("../Assets/Images/tik-tok.png"), label: "TikTok" },
  ].filter((link) => link.href);

  const titleBlock = (
    <div className="about-box-title">
      <p>Meet Your Musician</p>
      <h2>Discover the passion and talent behind your big day.</h2>
    </div>
  );

  // The heading lives in the text column, so the photo is centred against the whole card
  const imageColumn = musicianImage && (
    <Col lg={4} className="mt-4 mt-lg-0">
      <div className="about-img-sid">
        <img
          src={musicianImage}
          alt={musicianName}
          className={musician?.imageShape === "circle" ? "is-circle" : ""}
        />
      </div>
    </Col>
  );

  return (
    <Layout className="main-wrap">
      <Container fluid className="mt-4 p-0 custom-boxx">
        <Row>
          <Col lg={12}>
            <div className="about-box-sec">
              {musician ? (
                <Row className={`about-profile-row ${imageOnLeft ? "about-tow-sec-set" : "about-sec-set"}`}>
                  {imageOnLeft && imageColumn}

                  <Col lg={musicianImage ? 8 : 12}>
                    {titleBlock}
                    <div className="about-txt-side">
                      <h3>{musicianName}</h3>
                      {aboutParagraphs.map((paragraph, index) => (
                        <p key={index} style={{ whiteSpace: "pre-line" }}>{paragraph}</p>
                      ))}
                      {socialLinks.length > 0 && (
                        <ul className="social-list">
                          {socialLinks.map((link) => (
                            <li className="social-item" key={link.label}>
                              <a href={link.href} target="_blank" rel="noopener noreferrer">
                                <img src={link.icon} alt={link.label} />
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </Col>

                  {!imageOnLeft && imageColumn}
                </Row>
              ) : (
                titleBlock
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <div className="pb-4">
        <p className="mb-0"></p>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Request a change</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div>
            <Form>
              <div className="modal-cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Lorem ipsum dolor sit"
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button className="secondary" onClick={handleClose}>
            Close
          </button>
          <button className="primary" onClick={handleClose}>
            Request
          </button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}
